import React, { useMemo } from 'react';

// Per-realm color treatment for the D4 look:
// outline rows (alternating two colors) + a solid accent-filled row.
const REALM_TEXT = {
  anime: {
    outline1: 'rgba(0,0,0,0.22)',
    outline2: 'rgba(30,58,138,0.40)',
    fill: 'rgba(236,72,153,0.32)',
  },
  tantra: {
    outline1: 'rgba(220,38,38,0.32)',
    outline2: 'rgba(255,255,255,0.10)',
    fill: 'rgba(220,38,38,0.36)',
  },
  inkspeak: {
    outline1: 'rgba(0,0,0,0.20)',
    outline2: 'rgba(120,80,40,0.30)',
    fill: 'rgba(0,0,0,0.13)',
  },
  soul: {
    outline1: 'rgba(79,70,229,0.34)',
    outline2: 'rgba(0,0,0,0.14)',
    fill: 'rgba(251,146,60,0.38)',
  },
};

const ROW_COUNT = 8;

const RealmTextBg = ({ theme }) => {
  const cfg = REALM_TEXT[theme?.id] || REALM_TEXT.anime;
  const label = (theme?.label || 'OWLFIT').toUpperCase();
  const vibe = (theme?.vibe || 'Streetwear').toUpperCase();

  const rows = useMemo(() => {
    return Array.from({ length: ROW_COUNT }).map((_, i) => {
      const isVibe = i % 2 === 1;
      const word = isVibe ? `${vibe}\u00A0\u00A0` : `${label}\u00A0//\u00A0`;
      const block = word.repeat(8);
      const dir = i % 2 === 0 ? 'l' : 'r';
      const dur = `${70 + (i % 4) * 18}s`;

      let style;
      if (isVibe) {
        // solid accent-filled row
        style = { color: cfg.fill };
      } else {
        // outline row, alternating two outline colors
        const stroke = (i / 2) % 2 === 0 ? cfg.outline1 : cfg.outline2;
        style = { color: 'transparent', WebkitTextStroke: `2.5px ${stroke}` };
      }
      return { i, block, dir, dur, style };
    });
  }, [cfg, label, vibe]);

  return (
    <div className="fixed inset-0 z-0 overflow-hidden pointer-events-none flex flex-col justify-between py-6 select-none">
      {rows.map((row) => (
        <div key={row.i} className="w-full overflow-hidden">
          <div
            className={`rtb-track ${row.dir === 'l' ? 'rtb-l' : 'rtb-r'}`}
            style={{ '--dur': row.dur }}
          >
            <span
              className="font-black uppercase whitespace-nowrap leading-none tracking-tighter"
              style={{ fontSize: 'clamp(64px, 9vw, 120px)', ...row.style }}
            >
              {row.block}
            </span>
            <span
              className="font-black uppercase whitespace-nowrap leading-none tracking-tighter"
              style={{ fontSize: 'clamp(64px, 9vw, 120px)', ...row.style }}
              aria-hidden="true"
            >
              {row.block}
            </span>
          </div>
        </div>
      ))}
    </div>
  );
};

export default RealmTextBg;
